module.exports = __webpack_public_path__ + "img/blackjack.8c9f7215.png";